import React, { useMemo } from 'react';

import { UserAvatar } from '@/components/UserAvatar';
import UserAvatarGroup from '@/components/UserAvatar/UserAvatarGroup';
import { directMessageUrl } from '@/config/urls';
import { ChatType, ListMyChatsQuery, User } from '@/graphql';
import { classNames } from '@/helpers/classNames';
import { getChatTitleMembersRecipient } from '@/helpers/getChatChannelInfo';
import { useAuth } from '@/providers/AuthProvider';
import constants from '@/theme/exportedVariables.module.scss';
import { ButtonBase, useMediaQuery } from '@material-ui/core';
import { Link } from 'react-router-dom';

import styles from './MessagesCard.module.scss';

interface MessagesCardProps {
	chat: ListMyChatsQuery['listMyChats'][number];
	noHover?: boolean;
	hasNotification?: boolean;
}

export const MessagesCard: React.FC<MessagesCardProps> = ({
	chat,
	hasNotification,
}) => {
	const { user } = useAuth();
	const isTablet = useMediaQuery(`(min-width: ${constants.sizeTablet})`);

	const chatCardClasses = classNames([
		styles['chat-card'],
		isTablet && styles['chat-card--hover'],
	]);

	const type = useMemo(
		() => (chat.type === ChatType.Group ? 'group' : 'private'),
		[chat],
	);

	// We need to take the list of user ids from
	// the users field instead of `chat.userIds` as
	// the `userIds` field gives us the raw list with users that
	// potentially left the chat since it was created.
	const { title, userIds, recipientIds } = getChatTitleMembersRecipient(
		chat,
		user.id,
		user.displayName,
	);

	const SIZE = 50;

	const image =
		type === 'private' ? (
			<UserAvatar
				size="small"
				activeSize="small"
				notificationSize="small"
				userId={recipientIds[0]}
				hasNotification={hasNotification}
			/>
		) : (
			<UserAvatarGroup
				size="small"
				notificationSize="small"
				hasNotification={hasNotification}
				userIds={[userIds[0], userIds[1]]}
				activeSize="small"
				userAvatarProps={{
					size: 'xx-small',
					activeSize: 'small',
					borderColor: 'sheet',
				}}
			/>
		);

	return (
		<ButtonBase
			className={chatCardClasses}
			focusRipple
			component={Link}
			// link: `${directMessageUrl.replace(':token', chat.id)}`,
			// linkFrom: LinkFrom.messages,
			// type,
			// membersNames,
			// lastMessage: lastMessage?.content || 'No messages yet',
			// lastMessageAuthor:
			//   lastMessage?.user?.displayName || unknownDisplayName,
			// recipientName,
			// lastMessageTimestamp: getTimePassedAfterTimestamp(
			//   lastMessage?.createdAt || chat.createdAt,
			// ),
			// responsive: false,
			// name: chat?.name,
			// avatarOnly,

			to={`${directMessageUrl.replace(':token', chat.id)}`}
		>
			{/* <div className={styles['content']}> */}

			{image}
			<div className={styles['title']} style={{ width: SIZE + 10 }}>
				{title}
			</div>
			{/* </div> */}
		</ButtonBase>
	);
};
